const messages = {
    en: {
        delivery: {
            salesReport: {
                title: 'Reporte de ventas',
                actions: {
                    generate: 'Generar reporte',
                },
                fields: {
                    quantity: 'Cantidad',
                    amounts: 'Montos',
                },
                table: {
                    day: 'Día',
                    date: 'Fecha',
                    delivery: 'Delivery',
                    products: 'Productos',
                    quantity: 'Cantidad',
                    dozens: 'Docenas',
                    total: 'Total',
                    month: 'Mes',
                },
                warnings: {
                    requiredCategories: 'Debe seleccionar al menos una categoría para generar el reporte.',
                },
            },
        },
    },
    es: {
        delivery: {
            salesReport: {
                title: 'Reporte de ventas',
                actions: {
                    generate: 'Generar reporte',
                },
                fields: {
                    quantity: 'Cantidad',
                    amounts: 'Montos',
                },
                table: {
                    day: 'Día',
                    date: 'Fecha',
                    delivery: 'Delivery',
                    products: 'Productos',
                    quantity: 'Cantidad',
                    dozens: 'Docenas',
                    total: 'Total',
                    month: 'Mes',
                },
                warnings: {
                    requiredCategories: 'Debe seleccionar al menos una categoría para generar el reporte.',
                },
            },
        },
    },
    pt: {
        delivery: {
            salesReport: {
                title: 'Reporte de ventas',
                actions: {
                    generate: 'Generar reporte',
                },
                fields: {
                    quantity: 'Cantidad',
                    amounts: 'Montos',
                },
                table: {
                    day: 'Día',
                    date: 'Fecha',
                    delivery: 'Delivery',
                    products: 'Productos',
                    quantity: 'Cantidad',
                    dozens: 'Docenas',
                    total: 'Total',
                    month: 'Mes',
                },
                warnings: {
                    requiredCategories: 'Debe seleccionar al menos una categoría para generar el reporte.',
                },
            },
        },
    },
}

export default messages
